import { priceToPayStyles } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/styles'
import { PriceToPayBaseProps } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/types'
import Typography from '@/features/ui/typography'
import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface PriceToPayHeaderProps extends Pick<PriceToPayBaseProps, 'price' | 'headingVariant'> {
    TrailingAccessory?: ReactNode
}

const PriceToPayHeader: FC<PriceToPayHeaderProps> = ({
    price,
    headingVariant = 'h3',
    TrailingAccessory,
}) => {
    const { t } = useTranslation()

    return (
        <View style={priceToPayStyles.headerContent}>
            <Typography.Heading
                variant={headingVariant}
                numberOfLines={1}
                style={priceToPayStyles.title}
            >
                {t('common.overview.prices.total')}
            </Typography.Heading>
            {TrailingAccessory}
            <Typography.Heading
                variant={headingVariant}
                numberOfLines={1}
                style={priceToPayStyles.totalPrice}
            >
                {price}
            </Typography.Heading>
        </View>
    )
}

export default PriceToPayHeader
